export default {"src":"/_next/static/media/4stars.284dce87.svg","height":22,"width":107,"blurWidth":0,"blurHeight":0};